import React from 'react';
import { ReactReduxContext } from 'react-redux';
import store from './../../../store';
export const withReducer = (objReducers) => (WrappedComponent) => {
  class Extended extends React.Component {
    static WrappedComponent = WrappedComponent;
    constructor() {
      super();
      store.injectReducer(objReducers);
    }
    render() {
      return <WrappedComponent {...this.props} />;
    }
  }
  Extended.contextType = ReactReduxContext;
  return Extended;
};
export default withReducer;
